import { schema } from "normalizr";

export const folder = new schema.Entity("folders");

export const collection = new schema.Entity("collections", {
  folders: [folder],
});
